import { Component, Injector, OnInit } from "@angular/core";
import { DynamicService } from "src/app/services/dynamic.service";
import { token } from '../../roles/roles.component';

@Component({
    selector: 'role-lead',
    templateUrl: './role-lead.component.html',
    standalone: false
})
export class ContactLeadComponent implements OnInit {
    protected contactRoleId: number = 0
    protected contactId: number = 0
    protected dataIn: string;

    constructor(private serv: DynamicService, private inject: Injector) {
    }

    ngOnInit(): void {
        this.dataIn = this.inject.get(token);
        this.contactId = parseInt(this.dataIn['contactId'])
        this.contactRoleId = parseInt(this.dataIn['contactRoleId'])
    }

    reactivateRole() {
        this.serv.outputFromDynamicComponent({action: "reactivate", roleName: "salesLead"});
    }

    deactivateRole() {
        this.serv.outputFromDynamicComponent({ action: "deactivate", contactRoleId: this.contactRoleId });
    }
}